module.exports = __webpack_public_path__ + "img/Middle-Vertical-Rectangular-Attachment-36.5581bb42.png";